import { capabilityClient } from '../connect/clients';
export const capabilityApiConnect = {
    async ensureVendorLibraryProject (companyId) {
        const resp = await capabilityClient.ensureVendorLibraryProject({
            companyId
        });
        return {
            projectId: resp.projectId,
            projectName: resp.projectName,
            wasCreated: resp.wasCreated
        };
    },
    async listCapabilities (companyId, options) {
        return capabilityClient.listCapabilities({
            companyId,
            ...options
        });
    },
    async runCapabilityMatch (projectId, companyId) {
        return capabilityClient.runCapabilityMatch({
            projectId,
            companyId
        });
    },
    async getCapabilityGapAnalysis (projectId, companyId, requirementIds) {
        return capabilityClient.getCapabilityGapAnalysis({
            projectId,
            companyId,
            requirementIds: requirementIds ?? []
        });
    }
};
